import React from "react";
import "./overlayEffect.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchPlus } from '@fortawesome/free-solid-svg-icons';

const OverlayEffect = ({ children }) => {

    return (
        <div>
            <div className="container-overlay">
                {children}
                <div className="middle">
                    <div className="text"><FontAwesomeIcon icon={faSearchPlus} size="5x" className="text-light" /></div>
                </div>                
            </div>
            <legend className="badge badge-warning w-50 m-auto">Clique na imagem para ampliar</legend>
        </div>
    );
};
export default OverlayEffect;
